import { defineComponent, h, ref, useAttrs } from 'vue'
import { VTextarea } from 'vuetify/components'
import {
  resolveBgColor,
  resolveDensity,
  resolveVariant,
  stripLegacyInputAttrs,
  withLegacyDirtyClass
} from './legacyInputProps'

VTextarea.compatConfig = {
  ...(VTextarea.compatConfig || {}),
  COMPONENT_V_MODEL: false,
  INSTANCE_ATTRS_CLASS_STYLE: 'suppress-warning'
}

export default defineComponent({
  name: 'VTextareaCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input', 'change'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()
    let lastExternalValue
    const localValue = ref()

    return () => {
      const normalizedAttrs = withLegacyDirtyClass(
        stripLegacyInputAttrs(attrs),
        attrs
      )
      const legacyInput = normalizedAttrs.onInput
      const legacyChange = normalizedAttrs.onChange
      const variant = resolveVariant(attrs)
      const density = resolveDensity(attrs)
      const bgColor = resolveBgColor(attrs)
      const externalValue = attrs.modelValue ?? attrs.value
      if (lastExternalValue !== externalValue) {
        lastExternalValue = externalValue
        localValue.value = externalValue
      } else if (localValue.value === undefined) {
        localValue.value = externalValue
      }
      const modelValue = localValue.value
      const resolveEventValue = (value) =>
        value?.target ? value.target.value : value
      const notifyInput = (value) => {
        const resolvedValue = resolveEventValue(value)
        if (resolvedValue === localValue.value) return
        localValue.value = resolvedValue
        emit('update:modelValue', resolvedValue)
        emit('input', resolvedValue)
        if (typeof legacyInput === 'function') legacyInput(resolvedValue)
      }
      const notifyChange = (value) => {
        const resolvedValue = resolveEventValue(value)
        emit('change', resolvedValue)
        if (typeof legacyChange === 'function') legacyChange(resolvedValue)
      }

      delete normalizedAttrs.onInput
      delete normalizedAttrs.onChange
      delete normalizedAttrs['onUpdate:modelValue']

      return h(
        VTextarea,
        {
          ...normalizedAttrs,
          ...(variant ? { variant } : {}),
          ...(density ? { density } : {}),
          ...(bgColor ? { bgColor } : {}),
          modelValue,
          onInput: notifyInput,
          onChange: notifyChange,
          'onUpdate:modelValue': notifyInput
        },
        slots
      )
    }
  }
})
